


















import Vue from 'vue'
import { downloadFile } from '@/utils/index'

export default Vue.extend({
  name: 'ExportButton',
  props: ['filename', 'simple', 'disabled', 'exportFn', 'multi', 'selectedKeys'],
  methods: {
    async handleExport({ key }) {
      if (this.multi) {
        this.excute(key)
      } else {
        if (key === 'filter') { // 筛选结果导出
          this.excute()
        }
      }
    },
    async excute(type) {
      let res
      if (this.multi) {
        res = await this.exportFn(type)
      } else {
        res = await this.exportFn()
      }
      downloadFile(res, this.filename)
    }
  }
})
